import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Test Program layout. Pure pass-through `<Outlet />` wrapper so the routes
 * under `/test-program/` own their own breadcrumb + page-header layout. The
 * shared sidebar lives one level up (`_authenticated.tsx`), so this layer adds
 * nothing visual — it exists only to give TanStack Router a parent route to
 * mount the section's children under, which is also what keeps the sidebar's
 * prefix matcher highlighting Test Program across the whole section.
 */
export const Route = createFileRoute("/_authenticated/test-program")({
  component: TestProgramLayout,
});

function TestProgramLayout() {
  return <Outlet />;
}
